import { makeAutoObservable, runInAction } from 'mobx';

import ApiService from 'src/services/ApiService';
import { STORE_NAME } from 'src/utils/constants';
import { handleStateError } from 'src/errors';
import { HomeWidgetText } from 'src/models/homeWidgetText/HomeWidgetText';
import { RootStore } from './RootStore';

export default class HomeWidgetTextStore {
  private storeName = STORE_NAME.HOME_WIDGET_TEXT_STORE;
  private rootStore: RootStore;
  private apiService: ApiService;
  homeWidgetText?: HomeWidgetText;
  flatHomeWidgetText?: Map<string, string>;

  constructor(rootStore: RootStore, apiService?: ApiService) {
    makeAutoObservable(this);
    this.rootStore = rootStore;
    this.apiService = apiService || new ApiService(this.rootStore.authStore.getWhsAccessToken);
  }

  loadHomeWidgetText = async (): Promise<HomeWidgetText | undefined> => {
    try {
      const content = await this.apiService.getHomeWidgetText();
      if (content) {
        runInAction(() => {
          this.homeWidgetText = content;
          this.flatHomeWidgetText = new Map(Object.entries(content));
        });
      }

      return content;
    }
    catch (error) {
      handleStateError(error, this.storeName);
    }
  };

  getHomeWidgetText = (searchKey: string): string => {
    if (!this.flatHomeWidgetText)
      return searchKey;

    const normalizedKey = searchKey?.trim();
    const exactMatch = this.flatHomeWidgetText.get(normalizedKey);
    if (exactMatch) return exactMatch;

    return searchKey;
  };
}
